module.exports = __webpack_public_path__ + "img/trailer-icon-white.19e5cae4.png";